export default __webpack_public_path__ + "static/media/yearbook-cover.e3199b6e.jpg";